<template>
  <div
    class="flex gap-3"
    :class="{ 'items-center': alignItems == 'center' }"
  >
    <Avatar
      :url="avatarUrl"
      :size="size"
      :text="avatarText"
      :icon="avatarIcon"
      :is-logo="avatarIsLogo"
      :status-indicator-icon="statusIndicatorIcon"
      :status-indicator-color-class="statusIndicatorColorClass"
      :alt="alt"
    />
    <div>
      <router-link
        v-if="labelLink"
        :to="labelLink"
      >
        <div
          class="font-semibold"
          :class="{ link: labelLink }"
        >
          {{ label }}
        </div>
      </router-link>
      <div
        v-else
        class="font-semibold"
        :class="{ link: labelLink }"
      >
        {{ label }}
      </div>

      <div class="text-sm text-quaternary">
        <slot
          v-if="$slots['description']"
          name="description"
        />
        <div v-else>{{ description }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Avatar from '@/components/avatar/Avatar.vue'

defineProps({
  size: {
    type: String,
    default: 'md'
  },
  label: {
    type: String,
    required: true
  },
  labelLink: {
    type: String,
    default: null
  },
  description: {
    type: String,
    default: null
  },
  avatarUrl: {
    type: String,
    default: null
  },
  avatarText: {
    type: String,
    default: null
  },
  avatarIcon: {
    type: String,
    default: null
  },
  statusIndicatorIcon: {
    type: String,
    default: null
  },
  statusIndicatorColorClass: {
    type: String,
    default: null
  },
  avatarIsLogo: {
    type: Boolean,
    default: false
  },
  alignItems: {
    type: String,
    default: 'center'
  },
  alt: {
    type: String,
    default: null
  }
})
</script>

<style></style>
